import React from 'react';

const AdditionalInfoSection = () => {
  return (
    <div>
      <p>This is the additional info section</p>
    </div>
  );
};

export default AdditionalInfoSection;
